import { HttpService } from '../services/http';
import { StorageService } from '../services/storage';

export function GetFreeUniversityComponent() {
  const httpService = new HttpService();
  const storageService = new StorageService();
  const errorContainer = document.querySelector('#free-university-error-container');
  const emailInput = document.querySelector('#free-university-email');
  const submitButton = document.querySelector('#free-university-submit');

  /**
   * Initialize the component
   */
  window.addEventListener('load', () => {
    emailEvents();
    submitButton.addEventListener('click', () => onSubmit());
  });

  /**
   * Creates the event's listener for the email input
   */
  function emailEvents() {
    emailInput.addEventListener('blur', () => emailRequiredValidation());
    emailInput.addEventListener('keyup', () => emailRequiredValidation());
  }

  /**
   * Perform the email required validation
   */
  function emailRequiredValidation() {
    if (!emailInput.value) {
      toggleError(true, 'Email is required.');

      return false;
    }

    toggleError(false);

    return true;
  }

  /**
   * Toggle the error message
   *
   * @param show True to show the error message, false to hide it
   * @param errorMessage The error message to display
   */
  function toggleError(show, errorMessage) {
    if (!show) {
      errorContainer.classList.add('is-hidden');

      return;
    }

    errorContainer.children[0].innerHTML = `<span> <i class="fa fa-exclamation-triangle"></i> ${errorMessage}</span>`;
    errorContainer.classList.remove('is-hidden');
  }

  /**
   * Submits the form
   */
  function onSubmit() {
    event.preventDefault();

    if (!onSubmitValidations()) {
      return;
    }

    toggleError(false);
    const startedRequest = {
      email: emailInput.value,
      universities_id: emailInput.getAttribute('data-university-id'),
    };

    httpService
      .post(`${process.env.API_URL}/order-free-test`, startedRequest)
      .then((response) => handleValidResponse(response))
      .catch((error) => handleInvalidResponse(error));
  }

  /**
   * Perform the validations before submit the form
   */
  function onSubmitValidations() {
    if (!emailRequiredValidation()) {
      return false;
    }

    if (!emailInput.checkValidity()) {
      toggleError(true, 'Email is invalid.');

      return false;
    }

    return true;
  }

  /**
   * Handles an invalid response from the server
   *
   * @param response The response from the server
   */
  function handleInvalidResponse(response) {
    let errorResponse = 'There was an error. Please try again or contact us.';

    if (response.code === 417) {
      errorResponse = 'Please enter your school email address.';
    }

    toggleError(true, errorResponse);
  }

  /**
   * Handles a valid response from the server
   *
   * @param response The response from the server
   */
  function handleValidResponse(response) {
    storageService.tests = response.tests;
    storageService.email = response.email;
    storageService.free = response.free;
    window.location.href = '/order';
  }
}

window.changeLocation = new GetFreeUniversityComponent();
